import React from "react";
import { 
  AlertTriangle
} from "lucide-react";
import SimpleProjectDetails from "./simple-project-details";

interface ProjectOverviewProps {
  loading: boolean;
  projectId?: string;
  contractType?: string;
  contractAmount?: number;
  currency?: string;
  
  // Project details
  projectHeadline?: string;
  projectSummary?: string;
  
  // Enhanced display fields (simplified)
  hasOverdueClaims?: boolean;
  overdueClaimsCount?: number;
  
  // Project setup state
  contractExtracted?: boolean;
  isSetupMode?: boolean;
  
  // Action handlers for setup mode
  onConfirm?: () => void;
  onReExtract?: () => void;
}

export default function ProjectOverview({
  loading,
  projectId,
  contractType = "Fixed Price",
  contractAmount = 0,
  currency = "USD",
  
  // Project details
  projectHeadline = "",
  projectSummary = "",
  
  // Enhanced display fields
  hasOverdueClaims = false,
  overdueClaimsCount = 0,
  
  // Project setup state
  contractExtracted = false,
  isSetupMode = false,
  
  // Action handlers
  onConfirm,
  onReExtract
}: ProjectOverviewProps) {

  return (
    <div className="mt-4 mb-4">
      {/*  Simple Project Details - show when contract details are extracted OR not in setup mode */}
      {(contractExtracted || !isSetupMode) && (
        <div className="mb-6">
          <SimpleProjectDetails
            projectId={projectId}
            contractType={contractType}
            contractAmount={contractAmount}
            contractCurrency={currency}
            projectHeadline={projectHeadline}
            projectSummary={projectSummary}
            loading={loading}
            showActions={isSetupMode && contractExtracted}
            isSetupMode={isSetupMode}
            onConfirm={onConfirm}
            onReExtract={onReExtract}
          />
        </div>
      )}
    
      {/* Project-Level Alerts Bar */}
      {!loading && hasOverdueClaims && (
        <div className="mb-4">
          <div className="bg-amber-50 border-l-4 border-amber-400 p-3 rounded-md">
            <div className="flex">
              <div className="flex-shrink-0">
                <AlertTriangle className="h-4 w-4 text-amber-400" aria-hidden="true" />
              </div>
              <div className="ml-2 flex-1 md:flex md:justify-between">
                <div className="text-xs text-amber-700 flex flex-wrap gap-3">
                  <button className="inline-flex items-center font-medium hover:underline">
                    <span className="mr-1">📅</span> {overdueClaimsCount} claims overdue → lose leverage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
